export default __webpack_public_path__ + "static/media/bomba-aplicacao.7a12a710.png";